import { FC } from 'react'
import styles from './Pod4SeamlessSnoring.module.scss'
import { Pod4SeamlessSnoringProps } from './types'
import { Img } from 'components/basic/Img'
import { SnoreCard } from '../Phantom/SnoreCard'
import { Type } from 'components/Type'

export const Pod4SeamlessSnoring: FC<Pod4SeamlessSnoringProps> = (props) => {
	const {
		headline = 'Stop snoring, automatically',
		description = 'The Base of Pod 4 Ultra automatically elevates the head area so that you, or your partner, reduce or stop snoring without waking up.',
		showSeeHowMuchSection = true,
	} = props
	return (
		<section className={styles.container}>
			<div className={styles.wrapper}>
				<Type.MegaHeadline
					animateOnScroll
					as={'h2'}
				>
					The Pod has been clinically proven to reduce snoring by up to 45%<span className={styles.asterisk}>*</span>
				</Type.MegaHeadline>
				<article>
					<header>
						<Type.Headline2 as={'h3'}>{headline}</Type.Headline2>
						<Type.Body1>{description}</Type.Body1>
					</header>
					<Img
						className={styles.snoreImg}
						alt="Person sleeping and snoring"
						sources={[
							{
								src: 'https://eight-eightsleep-react.s3.us-east-2.amazonaws.com/assets/stop_snoring_blue_2_mobile.jpg',
								mediaQuery: '(max-width: 599px)',
								dprHeight: 1080,
							},
							{
								src: 'https://eight-eightsleep-react.s3.us-east-2.amazonaws.com/assets/stop_snoring_blue_2.jpg',
								mediaQuery: '(min-width: 600px)',
								dprHeight: 1080,
							},
						]}
						src="https://eight-eightsleep-react.s3.us-east-2.amazonaws.com/assets/stop_snoring_blue_2.jpg"
					/>
				</article>
				{showSeeHowMuchSection && <SeeHowMuch />}
			</div>
		</section>
	)
}

const SeeHowMuch: FC<Pod4SeamlessSnoringProps> = (props) => (
	<article>
		<header>
			<Type.Headline2 as={'h3'}>See how much you snore each night</Type.Headline2>
			<Type.Body1>Pod 4 detects and tracks snoring for up to two people at once. Rather than using a microphone to detect sound, the Pod tracks vibration patterns through sensors. </Type.Body1>
		</header>

		<div className={styles.image_container}>
			<Img
				className={styles.snoreImg}
				alt="Two people sleeping and snoring"
				sources={[
					{
						src: 'https://eight-eightsleep-react.s3.us-east-2.amazonaws.com/assets/seamles_snoring_top_mob_2904.png',
						mediaQuery: '(max-width: 599px)',
						dprHeight: 1080,
					},
					{
						src: 'https://eightsleep.imgix.net/assets/seamless_snoreing_top_29042024.png',
						mediaQuery: '(min-width: 600px)',
						dprHeight: 1080,
					},
				]}
				src="https://eightsleep.imgix.net/assets/seamless_snoreing_top_29042024.png"
			/>
			<div className={styles.snoreCard}>
				<SnoreCard />
			</div>
		</div>
	</article>
)
